import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var printMq = '@media print';
  return {
    choicesWrapper: {
      flexBasis: '25rem',
      padding: componentTheme.choicesWrapperPadding,
      marginTop: componentTheme.choicesWrapperMargin
    },
    filesListWrapper: {
      padding: "0 ".concat(componentTheme.filesListWrapperPadding)
    },
    printOnly: _defineProperty({
      display: 'none'
    }, printMq, {
      display: 'block'
    })
  };
};
export default generateStyle;